const firebaseConfig = {
  apiKey: process.env.VITE_FIREBASE_API_KEY,
  authDomain: "lipsurf-216216.firebaseapp.com",
  databaseURL: "https://lipsurf-216216.firebaseio.com",
  projectId: "lipsurf-216216",
  storageBucket: "lipsurf-216216.appspot.com",
  messagingSenderId: "79073411535"
};
export {
  firebaseConfig
};
